import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "status-in-process";
const pathData = "M200 33q9-17 24-25.5T256-1t32 8.5T312 33l192 354q8 13 8 30 0 25-18 44.5T448 481H64q-28 0-46-19.5T0 417q0-17 8-30zm24 248q0 14 9 23.5t23 9.5 23-9.5 9-23.5V153q0-13-9-22.5t-23-9.5-23 9.5-9 22.5v128zm70 110q0-16-11-27t-27-11-27 11-11 27q0 17 11 28t27 11 27-11 11-28z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/status-in-process";
export { pathData, ltr, accData };